import { render, staticRenderFns } from "./TrialsComponent.vue?vue&type=template&id=87c3e4ea&scoped=true"
import script from "./TrialsComponent.vue?vue&type=script&lang=js"
export * from "./TrialsComponent.vue?vue&type=script&lang=js"
import style0 from "./TrialsComponent.vue?vue&type=style&index=0&id=87c3e4ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c3e4ea",
  null
  
)

export default component.exports